module.exports = __webpack_public_path__ + "img/Shape.28cda336.svg";